../<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="showBackButton"
          :label="$t('List page')"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          :label="$t('Search')"
          size="md"
          icon="SearchIcon"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>
    <b-row class="position-relative">
      <b-col
        v-if="!showSearchButton"
        md="4"
      >
        <b-row>
          <Alert
            :show="showFormErrorAlert"
            :message="$t('Customer\'s account name or account number or customer id is required')"
          />

          <b-col md="12">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              :label="$t('Account Number')"
              :placeholder="$t('Enter account number')"
              type="text"
            />
          </b-col>

          <b-col md="12">
            <InputField
              id="account-name"
              v-model="searchParams.accountName"
              :label="$t('Account Name')"
              :placeholder="$t('Enter account name')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="reference-number"
              v-model="searchParams.referenceNumber"
              :label="$t('Reference Number')"
              :placeholder="$t('Enter reference number')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <Button
              :label="$t('Search')"
              size="md"
              class="mt-2"
              block
              @click="handleSearch"
            />
          </b-col>
        </b-row>

      </b-col>
      <b-col
        v-if="showSearchButton"
        :md="showSearchButton === true ? '12' : '8'"
      >
        <div v-if="showCustomerInfo">
          <validation-observer ref="cashDepositRules">
            <app-collapse
              class="business-items mb-4"
              type="margin"
              accordion
            >
              <app-collapse-item
                :title="$t('Account Summary')"
                class="card-item"
                is-visible
              >
                <b-row>
                  <b-col md="3">
                    <InputField
                      id="account-name"
                      v-model="customer.accountName"
                      :label="$t('Account Name')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="account-number"
                      v-model="depositData.accountNumber"
                      :label="$t('Account Number')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="product-name"
                      v-model="customer.productName"
                      :label="$t('Product Name')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="NUBAN"
                      v-model="customer.accountNumber"
                      :label="$t('NUBAN')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="branch"
                      v-model="customer.branchName"
                      :label="$t('Branch')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="account-status"
                      v-model="customer.accountStatus"
                      :label="$t('Account Status')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="ledger-balance"
                      v-model="customer.ledgerBalance"
                      :label="$t('Ledger Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="available-balance"
                      v-model="customer.availableBalance"
                      :label="$t('Available Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="withdrawable-balance"
                      v-model="customer.withdrawableBalance"
                      :label="$t('Withdrawable Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="overdraft-limit"
                      v-model="customer.overdraftLimit"
                      :label="$t('Overdraft Limit')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="account-officer"
                      v-model="customer.accountOfficer"
                      :label="$t('Account Officer')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="tier-level"
                      v-model="customer.accountTierLevel"
                      :label="$t('Tier Level')"
                      type="text"
                      readonly
                    />
                  </b-col>
                </b-row>
              </app-collapse-item>
            </app-collapse>

            <h5 class="text-capitalize mb-3">
              {{ $t('Posting Details') }}
            </h5>
            <b-row>
              <b-col md="6">
                <InputNumberField
                  id="amount"
                  v-model="depositData.amount"
                  :label="$t('Amount')"
                  :placeholder="$t('Enter amount')"
                  :error-name="$t('Amount')"
                  rules="required|positive"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="instrument-no"
                  v-model="depositData.instrumentNumber"
                  :label="$t('Instrument No')"
                  :placeholder="$t('Enter instrument no')"
                  type="text"
                  rules="required"
                  :error-name="$t('Instrument No')"
                  :on-input="setInstrumentNoNarration"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <SelectField
                  id="deposit-by"
                  v-model="depositedBy"
                  :label="$t('Deposited By')"
                  :options="translatedDepositByOptions"
                  :reduce="option => option.value"
                  :error-name="$t('Deposited By')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                  :readonly="isReadonly"
                  :set-selected="setDepositedBy"
                />
              </b-col>

              <b-col
                v-if="depositedBy === 'thirdParty'"
                md="6"
              >
                <InputField
                  id="depositor"
                  v-model="postingFormData.postingData.senderName"
                  :label="$t('Depositor')"
                  :placeholder="$t('Enter depositor')"
                  type="text"
                  for="depositor"
                  rules="required"
                  :error-name="$t('Depositor')"
                  :on-input="setPayeeNarration"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="narration"
                  v-model="depositData.narration"
                  :label="$t('Narration')"
                  :placeholder="$t('Enter narration')"
                  type="text"
                  rules="required"
                  error-name="narration"
                />
              </b-col>
            </b-row>
          </validation-observer>
          <div class="text-center mt-5">
            <Button
              :label="$t('Post')"
              :loading="isLoading"
              :disabled="isDisabled"
              size="lg"
              @click="handleSubmit"
            />
          </div>

        </div>
      </b-col>
    </b-row>

    <b-modal
      id="search-modal"
      ref="search-modal-lg"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Customer Details')"
      cancel-title-only
      @hidden="resetModal"
    >

      <b-table
        ref="customerListTable"
        select-mode="single"
        :items="customerList"
        responsive
        :fields="translatedTableHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>

    </b-modal>

    <b-modal
      id="memo-info-modal"
      ref="memoInfoModal"
      :ok-title="$t('Cancel')"
      ok-only
      :title="$t('Memo')"
      ok-variant="outline-secondary"
      centered
      no-close-on-backdrop
      size="lg"
    >
      <b-table
        ref="memoListTable"
        select-mode="single"
        :items="memoGetData"
        responsive
        :fields="translatedMemoListHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No data available')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
      >
        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>
      </b-table>
    </b-modal>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import moment from 'moment'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { mapActions, mapGetters } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toBalance, toKobo, toAmount } from '@/helpers/formatAmount'
import InputField from '../../../../forms/InputField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import Button from '../../../../components/button/Button.vue'
import Alert from '../../../../components/alert/Alert.vue'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import { postingPermissions } from '../../../../../helpers/permissions'
import { toDateWithYearFirst } from '../../../../../helpers/formatDate'

const today = new Date()
const dateTime = toDateWithYearFirst(moment(today).format())

const depositByOptions = [{ value: 'self', label: 'Self' }, { value: 'thirdParty', label: 'Third-Party' }]

export default {
  components: {
    BRow,
    BCol,
    InputField,
    SelectField,
    Button,
    TablePagination,
    Alert,
    BTable,
    BCard,
    FullScreenSpinner,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
    InputNumberField,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, tableMixins, modalMixins],
  data() {
    return {
      showFormErrorAlert: false,
      showCustomerInfo: false,
      showSearchButton: false,
      showBackButton: false,
      isEditable: true,
      isLoading: false,
      isDisabled: false,
      customerList: [],
      required,
      positive,
      showSpinner: false,
      sortDesc: false,
      currentPage: 1,
      selected: [],
      perPage: 10,
      sortBy: 'accountName',
      tillAccountNumber: '',
      tillAccountName: '',
      filteredResult: [],
      searchParams: {
        accountNumber: null,
        accountName: null,
        referenceNumber: null,
      },
      depositedBy: '',
      depositData: {
        accountNumber: '',
        accountName: '',
        amount: '',
        recordType: 'Credit',
        narration: '',
        // narration: `Cash Dep.: Instr.no ${this.depositData?.instrumentNumber !== undefined ? this.depositData?.instrumentNumber : ''} by ${this.postingFormData.postingData.senderName !== undefined ? this.postingFormData.postingData.senderName : ''}`,
        instrumentNumber: '',
        branchCode: '',
        depositBy: '',
      },
      postingFormData: {
        postingData: {
          realDate: dateTime,
          postingType: 'CashDepositPosting',
          senderName: '',
        },
      },
      posting: [],
      customer: {
        accountName: '',
        accountNumber: '',
        productName: '',
        branchName: '',
        accountStatus: '',
        ledgerBalance: '',
        availableBalance: '',
        withdrawableBalance: '',
        overdraftLimit: '',
        accountOfficer: '',
        accountTierLevel: '',
        minimumBalanceRequired: 0,
        accountCreationChannel: null,
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
      ],
      memoListHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountNumber', label: 'Account Number' },
        { key: 'actionType', label: 'Action Type' },
        { key: 'details', label: 'Reason' },
        { key: 'comments', label: 'Comments' },
        { key: 'initiatedBy', label: 'Initiated By' },
      ],
      memoGetData: [],

    }
  },
  computed: {
    totalEntries() {
      return this.customerList.length
    },
    numberOfPages() {
      return Math.floor((this.totalEntries + this.perPage - 1) / this.perPage)
    },
    from() {
      return (this.currentPage * this.perPage) - (this.perPage - 1)
    },
    to() {
      return Math.min(this.from + this.perPage - 1, this.totalEntries)
    },
    ...mapGetters({
      userData: 'auth/getCurrentUser',
      tillAccounts: 'operations/getTillAccount',
    }),
    translatedDepositByOptions() {
      return depositByOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedMemoListHeaders() {
      return this.memoListHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  async mounted() {
    // this.fetchTillAccount()
    // this.fetchTillAccount()
    // if (this.depositData.instrumentNumber) {
    // }
  },
  methods: {
    ...mapActions({
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      postCashDeposit: 'posting/postingAction',
      getUserBalance: 'account/getCASABalanceAction',
      getTillAccountList: 'operations/getTillAccountList',
    }),
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(params => (params === null || params === ''))
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          const response = await this.searchCustomerAccount({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission: 'CASH_DEPOSIT_POSTING',
          })
          const { status, data } = response
          if (status === 200 && data?.data) {
            this.customerList = data.data
            this.totalCount = data.recordCount
            this.showSpinner = false
            this.$root.$emit('bv::show::modal', 'search-modal')
          } else {
            this.customerList = []
            this.totalCount = data.recordCount
            this.$root.$emit('bv::show::modal', 'search-modal')
          }
        } else {
          this.showFormErrorAlert = true
          this.showSpinner = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    setDepositedBy(val) {
      if (val === 'self') {
        this.postingFormData.postingData.senderName = this.depositData.accountName
        this.depositData.narration = `Cash Dep.: Instr.no ${this.depositData.instrumentNumber} by ${this.depositData.accountName}`
      } else {
        this.postingFormData.postingData.senderName = ''
        this.depositData.narration = `Cash Dep.: Instr.no ${this.depositData.instrumentNumber} by ${this.postingFormData.postingData.senderName}`
      }
    },
    setPayeeNarration(val) {
      this.postingFormData.postingData.senderName = val
      this.depositData.narration = `Cash Dep.: Instr.no ${this.depositData.instrumentNumber} by ${this.postingFormData.postingData.senderName}`
    },
    setInstrumentNoNarration(val) {
      this.depositData.instrumentNumber = val
      this.depositData.narration = `Cash Dep.: Instr.no ${this.depositData.instrumentNumber} by ${this.postingFormData.postingData.senderName}`
    },
    async onSelectCustomer(items) {
      try {
        const [customer] = items
        this.hideModal('search-modal')
        this.showSpinner = true
        const response = await this.getUserBalance({ accountNumber: customer.accountNumber, permission: 'CASH_DEPOSIT_POSTING' })
        const { data, status } = response
        if (status === 200) {
          this.customer = {
            ...customer,
            availableBalance: toBalance(data.availableBalance),
            withdrawableBalance: toBalance(data.withdrawableBalance),
            overdraftLimit: toBalance(data.overdraftLimit),
            ledgerBalance: toBalance(data.ledgerBalance),
            accountOfficer: data.accountOfficerName,
          }
        }
        if (data.memos !== null) {
          this.memoGetData = data.memos
          this.$root.$emit('bv::show::modal', 'memo-info-modal')
        }
        this.depositData.accountNumber = customer.accountNumber
        this.depositData.accountName = customer.accountName
        this.depositData.branchCode = customer.branchCode
        this.depositData.narration = `Cash Dep.: Instr.no ${this.depositData.instrumentNumber} by ${this.postingFormData.postingData.senderName}`
        this.showCustomerInfo = true
        this.showSearchButton = true
        this.showBackButton = true
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async handleSubmit() {
      this.$refs.cashDepositRules.validate().then(success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to initiate a cash deposit of')
          this.confirm(this.cashDepositAction, { text: `${areYouSure} ${toAmount(this.depositData.amount)} ?` })
        }
      })
    },
    // eslint-disable-next-line consistent-return
    async getTillUserAccount() {
      try {
        const response = await this.getTillAccountList({
          search: {
            tellerUserID: this.userData.id,
          },
          permission: 'CASH_DEPOSIT_POSTING',
        })
        const { data, status } = response

        if (data.data !== null && status === 200) {
          this.tillAccountNumber = data.data[0].accountNumber
          this.tillAccountName = data.data[0].accountName
          return true
        }
        if (data.data == null && status === 200) {
          this.alertError({ text: this.$t('Till Account has not been configured for you') })
          return false
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    async cashDepositAction() {
      try {
        const hasTillAccountConfigured = await this.getTillUserAccount()
        if (hasTillAccountConfigured) {
          this.isLoading = true
          this.isDisabled = true
          const postingApprovalModel = {
            amount: toKobo(this.depositData.amount),
            accountName: this.depositData.accountName,
            initiatedBy: '',
            approvedBy: '',
            postingType: 'CashDepositPosting',
          }
          this.postingFormData.postingApprovalModel = postingApprovalModel
          this.postingFormData.postingData.initiatedBy = this.userData.email
          this.postingFormData.postingEntry = [
            {
              accountNumber: this.depositData.accountNumber,
              accountName: this.depositData.accountName,
              amount: toKobo(this.depositData.amount),
              recordType: 'Credit',
              narration: this.depositData.narration,
              instrumentNumber: this.depositData.instrumentNumber,
              entryCode: 'C-CSHD',
              branchCode: this.depositData.branchCode,
            },
            {
              accountNumber: this.tillAccountNumber,
              accountName: this.tillAccountName,
              amount: toKobo(this.depositData.amount),
              recordType: 'Debit',
              narration: this.depositData.narration,
              instrumentNumber: this.depositData.instrumentNumber,
              entryCode: 'D-CSHD',
              branchCode: this.userData.branchCode,
            }]
          const postingData = this.postingFormData
          const response = await this.postCashDeposit({ postingData, permission: postingPermissions.CASH_DEPOSIT_POSTING })

          const { status, data } = response
          if (status === 200 && data.isSuccessful) {
            this.showCustomerInfo = false
            this.isLoading = false
            this.isDisabled = false
            this.resetInputField()
            this.resetSearchParams()
            const depositSuccess = this.$t('Your Cash deposit request was successful. Cash deposit reference ID is')
            this.alertSuccess({ text: `${depositSuccess} ${data.referenceNumber}` })
            this.$router.push('cash-deposit')
          }
          if (status === 200 && !data.isSuccessful) {
            const failedText = this.$t('Your Cash deposit request failed. Reason:')
            this.alertError({ text: `${failedText} ${data.message}` })
          }
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    resetInputField() {
      this.searchParams = { ...null }
      this.depositData = { ...null }
      this.customer = { ...null }
      this.isLoading = false
      this.isDisabled = false
      this.showCustomerInfo = false
      this.showSearchButton = false
      this.showBackButton = false
    },
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
    },
    resetSearchParams() {
      this.searchParams.accountNumber = null
      this.searchParams.accountName = null
      this.searchParams.referenceNumber = null
    },
    resetModal() {
      this.customerList = []
    },
    backNavigationAction() {
      this.$router.push({
        name: 'cash-deposit',
      })
    },

  },
}
</script>
<style scoped>
 [dir] .demo-inline-spacing > *, .custom-control , .custom-control-inline, .custom-checkbox {
    margin-top: 0rem !important;
}
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}
</style>
